import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CallLogFilters } from '../../models/call-history.model';

@Component({
  selector: 'app-call-history-filter-popup',
  templateUrl: './call-history-filter-popup.component.html',
  styleUrls: ['./call-history-filter-popup.component.scss'],
})
export class CallHistoryFilterPopupComponent {
  @Input() hideOnInitPage = true;
  @Input() open = false;
  @Output() closing: EventEmitter<void> = new EventEmitter();
  @Output() filtersChanged: EventEmitter<CallLogFilters> = new EventEmitter();
  public closingPopup: { isClosed?: boolean; reason?: 'close' | 'apply' } = {
    isClosed: !this.open,
    reason: 'close',
  };

  public onFiltersChange(outputFilters: CallLogFilters): void {
    this.filtersChanged.emit(outputFilters);
    this.closingPopup = { isClosed: !this.open, reason: 'apply' };
    this.closing.emit();
  }

  public close(): void {
    this.closingPopup = { isClosed: !this.open, reason: 'close' };
    this.closing.emit();
  }
}
